if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          if (target) target.addPreProcessCallback?.(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement?.(this.openedBy);
        if (this.modalContent) this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        if (!opener || opener.getAttribute('aria-disabled') === 'true') return;

        const productUrl = opener.getAttribute('data-product-url');
        const spinner = opener.querySelector('.loading__spinner');
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        spinner?.classList.remove('hidden');

        if (!productUrl || !this.modalContent) {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          spinner?.classList.add('hidden');
          return;
        }

        fetch(productUrl)
          .then((response) => {
            if (!response.ok) throw new Error(`Quick Add request failed with ${response.status}`);
            return response.text();
          })
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');
            if (!productElement) throw new Error('Quick Add product content was missing.');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);
          })
          .catch((error) => {
            console.error('[Glowinex Quick Add] Product load failed.', error);
            if (this.modalContent) {
              this.modalContent.innerHTML = '<div class="quick-add-modal__content-info center" role="alert" style="padding:3rem 2rem"><p>We couldn’t load this product right now. Please close this window and try again.</p></div>';
              super.show(opener);
            }
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            spinner?.classList.add('hidden');
          });
      }

      preprocessHTML(productElement) {
        if (!productElement || !this.modalContent) return;

        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient') this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement?.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        if (!productElement) return;
        productElement.querySelector('pickup-availability')?.remove();
        productElement.querySelector('product-modal')?.remove();
        productElement.querySelectorAll('modal-dialog').forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        if (!productElement?.dataset.section) return;
        const sectionId = productElement.dataset.section;
        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });
        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement?.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;
        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement?.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
